import Vue from 'vue'
import Vuex from 'vuex'
import { handleTree } from "@/utils/tree";
import { getNavigationBarData } from "@/api/front";
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isMobile: '',
    navList: []
  },
  getters: {
    isMobile: state => state.isMobile,
    navList: state => state.navList
  },
  mutations: {
    SET_ISMOBILE: (state, isMobile) => {
      state.isMobile = isMobile
    },
    SET_NAVLIST: (state, navList) => {
      state.navList = navList;
    },
  },
  actions: {
    // 异步获取数据并存储到 state 中
    async fetchListData({ commit, state }) {
      // if (state.navList.length > 0) {
      //   return
      // }
      try {
        const response = await getNavigationBarData(); 
        const data = response.data.filter((e) => e.name !== "首页");
        let navData = handleTree(data);
        if(navData != state.navList){
          commit('SET_NAVLIST', navData);
        }
       
      } catch (error) {
        console.error('获取数据失败', error);
      }
    },
  },
  modules: {
  },
  plugins: [createPersistedState({
    paths: ['navList'] // 只持久化 navList
  })]
})
